@if (profileField$ | async; as profileField) {
  <sh-form-group
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [required]="profileField.Required"
    [helpText]="profileField.Description"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [title]="disabledMessageKey | translate"
    [labelActionItems]="globalActionItems$ | async"
    >
    @if (isIndeterminate) {
      <p class="sh-form-group__feedback">{{ "general.only-matching-values-shown" | translate }}</p>
    }
    <!-- Merge Strategy Component-->
    <ng-content></ng-content>
    <form [formGroup]="list" [id]="profileField.DottedKey">
      @for (currentValueFormGroup of list.controls; track currentValueFormGroup; let i = $index) {
        @if (childProfileField$ | async; as childProfileField) {
          <div class="sh-form-group sh-child-field-group" [style]="nestedPadding$ | async">
            <div class="sh-action-group" style="margin-bottom: 0px">
              <div class="sh-action-group__item">
                <label
                  ><i>{{ childDefinitionLabel$ | async }} {{ i + 1 }}</i></label
                  >
                </div>
                @if (childActionItems$ | async; as actionItems) {
                  <div class="sh-action-group__item">
                    @for (actionItem of actionItems[i]; track actionItem) {
                      <sh-action-item [item]="actionItem"></sh-action-item>
                    }
                  </div>
                }
              </div>
              @if (childProfileField.FieldDefinition) {
                <med-address-field
                  [profileField]="childProfileField"
                  [control]="currentValueFormGroup"
                  [records]="[flattenedComplexListFieldRecords[i]]"
                  [isBatchEdit]="isBatchEdit"
                  [errorMsg]="currentValueFormGroup.getError('message')"
                  [autocompleteFct]="autocompleteFct"
                  [nestedIndex]="(nestedIndex$ | async)! + 1"
                  >
                </med-address-field>
              } @else {
                <dt class="sh-description-list__term">{{ childProfileField.DisplayLabel }}</dt>
                <dd class="sh-description-list__details">
                  {{ "form.error.fielddefinition-not-found" | translate: { id: childProfileField.FieldDefinitionId } }}
                </dd>
              }
            </div>
          }
        }
      </form>
    </sh-form-group>
  }

  <ng-template #batchMode>
    <ng-content></ng-content>
  </ng-template>
